import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import NotificationPreferences, {
  INotificationPreferencesDispatchProps,
  INotificationPreferencesProps,
} from './NotificationPreferences'
import {
  getUserPreferencesLastUpdate,
  getUserPreferencesList,
  getUserPreferencesLoading,
} from './store/NotificationPreferencesSelectors'
import { cancelUserPreferences, editUserPreferences, getUserPreferences } from './store/NotificationPreferencesActions'
import { getUserCompanies } from '../../common/auth/authSelectors'

const mapStateToProps = (state: IGlobalState, ownProps: any): INotificationPreferencesProps => ({
  preferences: getUserPreferencesList(state),
  isLoading: getUserPreferencesLoading(state),
  lastUpdate: getUserPreferencesLastUpdate(state),
  isDuringRegistration: ownProps.isDuringRegistration,
  userCompanies: getUserCompanies(state),
})

const mapDispatchToProps: INotificationPreferencesDispatchProps = {
  getUserPreferences,
  editUserPreferences,
  cancelUserPreferences,
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationPreferences)
